type SparklinePoint = {
  start: string;
  end: string;
  value: number | null;
};

type Sparkline = {
  granularity: string;
  points: SparklinePoint[];
};

/**
 * Turns a KPI sparkline payload into the dataset shape `FocusSummaryCard`'s LineChart wants.
 *
 * Consecutive repeated values are collapsed to a single point so a flat series renders as a
 * short line rather than a long stretch of identical nodes.
 */
export const sparklineToChartData = (sparkline: Sparkline) => {
  const values = sparkline.points.map((p) => p.value);
  const labels = sparkline.points.map((p) => p.end);

  const cleanedValues: number[] = [];
  const cleanedLabels: string[] = [];

  values.forEach((val, i) => {
    if (i === 0 || val !== values[i - 1]) {
      cleanedValues.push(val ?? 0);
      cleanedLabels.push(labels[i]);
    }
  });

  return {
    labels: cleanedLabels,
    datasets: [
      {
        label: sparkline.granularity,
        data: cleanedValues,
        borderColor: '#165BAA',
        backgroundColor: 'rgba(22, 91, 170, 0.2)',
      },
    ],
  };
};
